var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Employee_ID_1923766",
    transform: "translate(-5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9458",
    d: "M44.4,9.1H34.1V3.9H23.9v5.1H13.6c-1.4,0-2.6,1.1-2.6,2.6v0v35.9c0,1.4,1.1,2.6,2.6,2.6c0,0,0,0,0,0h30.8 c1.4,0,2.6-1.1,2.6-2.6l0,0V11.6C46.9,10.2,45.8,9.1,44.4,9.1L44.4,9.1z M44.4,47.5H13.6V11.6h30.8V47.5z M29,29.6 c3.5,0,6.4-2.9,6.4-6.4c0-3.5-2.9-6.4-6.4-6.4c-3.5,0-6.4,2.9-6.4,6.4c0,0,0,0,0,0C22.6,26.7,25.5,29.6,29,29.6z M29,19.3 c2.1,0,3.8,1.7,3.8,3.8S31.1,27,29,27s-3.8-1.7-3.8-3.8l0,0C25.2,21,26.9,19.3,29,19.3z M39.3,37.2c0-2.8-2.3-5.1-5.1-5.1H23.9 c-2.8,0-5.1,2.3-5.1,5.1v2.6h20.5L39.3,37.2z M36.7,37.2H21.3c0-1.4,1.1-2.6,2.6-2.6h0h10.3C35.6,34.7,36.7,35.8,36.7,37.2 L36.7,37.2L36.7,37.2z M18.8,42.4L18.8,42.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeId);
export default __webpack_public_path__ + "static/media/Employee ID.79b4c89821d03e59adc4d65e50937ede.svg";
export { ForwardRef as ReactComponent };